import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

import { FormSectionFields } from './fields';

const t = getTranslation('donor.ValidationErrors');

const { Veterinarian, AnimalName, Notes, DonorId, ExaminationDate } =
  FormSectionFields;

type DvmExamFormSchemaType = {
  donorId: string;
  veterinarian: string;
  animalName: string;
  examinationDate: Date;
  notes?: string;
};

const dvmExamFormSchemaType: yup.SchemaOf<DvmExamFormSchemaType> = yup.object({
  [DonorId]: yup.string().required(),
  [Veterinarian]: yup
    .string()
    .required(t('required', { field: t('veterinarian') })),
  [AnimalName]: yup
    .string()
    .required(t('required', { field: t('animalName') })),
  [ExaminationDate]: yup
    .date()
    .typeError(t('mustBeDate'))
    .max(
      new Date(new Date().setHours(23, 59, 59, 999)),
      t('dvmExamDateCannotBeInFuture')
    )
    .required(t('required', { field: t('collectionDate') })),
  [Notes]: yup.string(),
});

export { dvmExamFormSchemaType };
export type { DvmExamFormSchemaType };
